import { useEffect, useCallback, useState } from "react";
import { fetchAllDrivers, fetchAvailableDrivers } from "../services/dashboard";

export const useDrivers = (opts?: { availableOnly?: boolean; branchId?: string; branchLocation?: string }) => {
  const [drivers, setDrivers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchDrivers = useCallback(async () => {
    setLoading(true);
    try {
      const res = opts?.availableOnly
        ? await fetchAvailableDrivers(0, 1000, opts?.branchLocation, opts?.branchId)
        : await fetchAllDrivers(0, 50, opts?.branchLocation, opts?.branchId);
      setDrivers(res.data?.drivers || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [opts?.availableOnly, opts?.branchId, opts?.branchLocation]);

  useEffect(() => {
    fetchDrivers();
  }, [fetchDrivers]);

  return { drivers, loading, fetchDrivers };
};
